import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-comment',
  templateUrl: './icon-comment.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCommentComponent {}
